import { render, staticRenderFns } from "./ContentCard.vue?vue&type=template&id=8d7b9a3c&scoped=true"
import script from "./ContentCard.vue?vue&type=script&lang=js"
export * from "./ContentCard.vue?vue&type=script&lang=js"
import style0 from "./ContentCard.vue?vue&type=style&index=0&id=8d7b9a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7b9a3c",
  null
  
)

export default component.exports